var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 73,
    viewBox: "0 0 97 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.552 53.8932V56.0753L51.1099 39.9585V37.7764L90.552 53.8932Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0918 5.56299V7.74512L51.11 39.956V37.7738L51.0918 5.56299Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.552 53.8932V56.0753L51.1099 39.9585V37.7764L90.552 53.8932Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1011 5.56299V7.74512V39.956V37.7738V5.56299Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6587 53.8818V56.0639L51.1099 39.9585V37.7764L11.6587 53.8818Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1099 37.7764V39.9585V37.7764Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6636 37.7764C96.6642 43.715 94.49 49.4482 90.5518 53.8932V56.0753C94.49 51.6304 96.6642 45.8971 96.6636 39.9585V37.7764Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1099 37.7764V39.9585V37.7764Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5521 53.8927C77.9644 69.2951 50.0997 74.5672 28.317 65.6658C21.8344 63.2523 16.0928 59.1906 11.6587 53.8813V56.0635C24.2372 71.4703 52.0997 76.7493 73.8869 67.8547C80.3709 65.4424 86.1146 61.3825 90.5521 56.0749V53.8927Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1099 37.7764V39.9585V37.7764Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1011 5.56299C76.2604 5.56299 96.6595 19.9778 96.6641 37.767C96.6646 43.71 94.487 49.4471 90.5432 53.8929L51.1102 37.7761L51.1011 5.56299Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5521 53.8932C77.9644 69.2955 50.0997 74.5677 28.317 65.6662C21.8344 63.2528 16.0928 59.1911 11.6587 53.8818L51.1099 37.7764L90.5521 53.8932Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10791 49.3305V51.5127L46.5592 35.4072V33.2251L7.10791 49.3305Z",
    fill: "#4F0C84",
    stroke: "#707070",
    strokeWidth: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10756 49.3308C3.17484 44.8877 1.00411 39.1589 1.00488 33.2253V35.4075C1.00488 17.6228 21.3881 3.20344 46.5406 3.19662V1.01221C21.3881 1.01903 1.00488 15.4384 1.00488 33.2253V35.4075C1.00411 41.3411 3.17484 47.0698 7.10756 51.5129V49.3308Z",
    fill: "#4F0C84",
    stroke: "#707070",
    strokeWidth: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11 49.3307C-5.46853 33.9238 1.99712 14.2232 23.7843 5.32856C31.0007 2.37062 38.7401 0.900151 46.5385 1.00526L46.5704 33.2252L7.11 49.3307Z",
    fill: "#4F0C84",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2);
export default __webpack_public_path__ + "static/media/Chart2.efe727e47d09149fb3c9500421c4b8d9.svg";
export { ForwardRef as ReactComponent };